<template>
  <div class="my-3">
    <div
      class="bg-gray-450 p-4 md:w-full pl-6 rounded-full w-8/12 xs:w-full sm:w-full lg:w-10/12 flex items-center"
      :class="{ active: isActive }"
    >
      <input
        name="paymentMethod"
        type="radio"
        value="card"
        class="mr-3"
        :model-value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <label for="paymentMethod" class="font-medium">Tarjeta de Crédito</label>
    </div>
    <div
      v-if="isActive"
      class="bg-gray-450 p-4 md:w-full pl-6 pt-6 rounded-br-3xl rounded-bl-3xl transition-all"
    >
      <PaymentCard 
        :information="information"
        :url="url"
        systemId="DISH"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import PaymentCard from './PaymentCard.vue';

const props = defineProps({
  modelValue: String,
  information: Object,
  url: String
});

defineEmits(['update:modelValue']);

const isActive = computed(() => props.modelValue === 'card');
</script>

<style scoped>
.active {
  @apply rounded-br-none rounded-bl-none bg-red text-white rounded-tr-2xl rounded-tl-2xl w-full;
}
</style>
